import { TableColumn } from "../types/ab";
import { ACTUAL_DURATION, ANALYSED_DURATION, CREATED_BY, CREATED_ON, ENDED_ON, MODIFIED_BY } from "./Constants";

export const generateColumns = <T extends object>(data: T[]): TableColumn<T>[] => {
  if (data.length === 0) return [];

  return Object.keys(data[0]).map((key) => {
    const column: TableColumn<T> = {
      header: key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').trim(),
      accessor: key as keyof T,
      sortable: true,
    };

    if (key === 'applets') {
      column.render = (row: T) => {
        const applets = (row[key as keyof T] as unknown) as { applet_id: string }[];
        return applets[0]?.applet_id;
      };
    } else if (key === 'result') {
      column.render = () => 'View Results';
    }

    return column;
  });
};

// temp
export const data = [
  { caption: CREATED_ON, label: "30-May-2024" },
  { caption: ENDED_ON, label: "13-Jun-2024" },
  { caption: ANALYSED_DURATION, label: "14 Days" },
  { caption: ACTUAL_DURATION, label: "14" },
  { caption: CREATED_BY, label: "Patrick" },
  { caption: MODIFIED_BY, label: "-" }
];

export const metricItems = [
  "Revenue",
  "Add To Cart Rate",
  "Interactions Conversion Rate",
  "Order Conversion Rate",
  "Score",
];
export const promotionpreferenceItems = [
  "Auto-promote Control",
  "Auto-promote Winner",
  "Run Indefinitely",
]

export const tooltips: Record<string, string> = {
  Revenue: "Total sales generated over a period.",
  Customers: "Number of unique customers who engaged with Compatio apps.",
  "Add To Cart Rate": "Percentage of sessions where users add items to cart. Calculated as: (Cart additions / App loads) x 100.",
  "Interactions Conversion Rate": "Percentage of user interactions that result in orders. Calculated as: (Orders / Total interactions) x 100.",
  "Order Conversion Rate": "Percentage of sessions that convert to orders. Calculated as: (Orders / App loads) x 100.",
  Score:
    "Score allows for multiple metrics to be used. Selected metrics will be multiplied with their weights and summed up to create a combined Score.",
  "Minimum Lift Percentage": "Enter the minimum percentage improvement required in the selected metric's value " +
    "for the variant(s) compared to the control model. Enter as a whole number (20 not 0.2 or 20%)",
  "Minimum Lift Percentage Note": "Note: Absolute metric values are normalized based on traffic distribution and Compatio App " +
    "impression count before calculating the actual lift percentage",
  Auto_promote_control:
    "\u2022 Auto_promote_control: The control model will automatically be promoted",
  Auto_promote_winner:
    "\u2022 Auto_promote_winner: The model with the best performance will be promoted",
  Run_Indefinitely:
    "\u2022 Run_Indefinitely: The test continues until you manually stop it",
  Note:
    "Note: You can always manually stop the test or promote any model at any time, regardless of this setting",
  Choose_promotion_preference: "Choose what happens when your A/B test reaches its scheduled end time"
};


export const scheduleItems = [
  "Daily",
  "Weekly",
  "Monthly",
  "Quarterly",
  "Annually",
  //"Seasonal"
];

export const getDaysBetween = (testDuration: number, analyzed_duration: number): number => {
  const days = testDuration - analyzed_duration;
  return days;
};

export const convertToDateMonthYear = (dateStr: string): string => {
  if (!dateStr) {
    return '';
  }
  const date = new Date(dateStr);

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return formattedDate;
};

export const capitalizeFirstLetter = (string: string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}

const APPLET_TO_WIDGET_MAP: Record<string, string> = {
  'Applet 1': 'Widget 1',
  'Applet 2': 'Widget 2',
  'Applet 3': 'Widget 3',
  'Applet 4': 'Widget 4',
};

export const mapAppletToWidget = (name: string): string =>
  APPLET_TO_WIDGET_MAP[name] ?? name;

export const compareUsernames = (ownerUsername: string, currentUsername: string): boolean => {
  if (!ownerUsername || !currentUsername) return false;
  
  const normalizedOwner = ownerUsername.toLowerCase().trim();
  const normalizedCurrent = currentUsername.toLowerCase().trim();
  
  if (normalizedOwner === normalizedCurrent) return true;
  
  const ownerParts = normalizedOwner.split(' ');
  const currentParts = normalizedCurrent.split(' ');
  
  const ownerFirstName = ownerParts[0];
  const currentFirstName = currentParts[0];
  
  return ownerFirstName === currentFirstName;
};
